import { Kicker, Reveal, scrollToId } from "./Reveal";
import { ArrowUpRight } from "lucide-react";

const IMG = {
  inhaber: "/images/team/inhaber.jpg",
  geselle: "/images/team/geselle.jpg",
  azubine: "/images/team/azubine.jpg",
};

const Caption = ({ title, sub }) => (
  <figcaption className="pt-5">
    <p className="font-display text-xl font-semibold text-ink tracking-tight flex items-center gap-2.5">
      <span className="w-2 h-2 bg-gold rotate-45 shrink-0" aria-hidden="true" />
      {title}
    </p>
    <p className="font-mono text-[10px] uppercase tracking-[0.22em] font-bold text-golddark mt-1.5">{sub}</p>
  </figcaption>
);

export const Team = () => (
  <section className="py-24 md:py-32 bg-surface border-b border-line" data-testid="team-section">
    <div className="container-x">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-12 md:mb-16">
        <div>
          <Reveal>
            <Kicker>Menschen</Kicker>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 data-testid="team-title" className="font-display text-4xl sm:text-5xl font-semibold tracking-tight leading-[1.08] mt-4 text-ink">
              Die Gesichter <span className="font-fraktur text-golddark">hinter dem Pinsel.</span>
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.16} className="max-w-md">
          <p className="text-muted leading-relaxed">
            Kein anonymer Betrieb: Bei Berglar kommt der Meister noch selbst auf die Baustelle. Lernen Sie die
            Menschen kennen, die Ihre Projekte ausführen.
          </p>
        </Reveal>
      </div>

      <div className="flex flex-col gap-12">
        <Reveal>
          <figure className="flex flex-col max-w-xl" data-testid="team-portrait">
            <div className="group relative border border-line rounded-xl overflow-hidden aspect-[2/3]">
              <div className="absolute top-0 left-0 right-0 h-[3px] bg-gold z-10" aria-hidden="true" />
              <img
                src={IMG.inhaber}
                alt="Manfred Berglar, Malermeister und Inhaber – Porträt mit Firmenwappen und dem Leitsatz „Qualität, die bleibt – seit Generationen“"
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.02]"
              />
            </div>
            <Caption title="Manfred Berglar" sub="Malermeister · Inhaber" />
          </figure>
        </Reveal>

        <Reveal delay={0.08}>
          <figure className="flex flex-col max-w-xl" data-testid="team-geselle">
            <div className="group relative border border-line rounded-xl overflow-hidden aspect-[2/3]">
              <img
                src={IMG.geselle}
                alt="Unser Geselle – seit über zwei Jahrzehnten im Betrieb, mit dem Leitsatz „Gutes Handwerk hält ein Leben lang“"
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.02]"
              />
            </div>
            <Caption title="Unser Geselle" sub="Seit über zwei Jahrzehnten dabei" />
          </figure>
        </Reveal>

        <Reveal delay={0.08}>
          <figure className="flex flex-col max-w-xl" data-testid="team-azubine">
            <div className="group relative border border-line rounded-xl overflow-hidden aspect-[2/3]">
              <img
                src={IMG.azubine}
                alt="Unsere Auszubildende im 3. Lehrjahr – mit dem Leitsatz „Ich lerne heute für ein noch bunteres Morgen“"
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.02]"
              />
            </div>
            <Caption title="Unsere Auszubildende" sub="3. Lehrjahr · Die nächste Generation" />
          </figure>
        </Reveal>

        <Reveal delay={0.1}>
            <blockquote className="border-l-2 border-gold pl-6 py-2 font-display text-2xl md:text-3xl font-medium leading-snug text-ink/90 max-w-3xl">
              „Am Ende zählt nur eins: dass Sie mit dem Ergebnis zufrieden sind. Dafür arbeiten wir – jeden Tag,
              mit ruhiger Hand.“
            </blockquote>
            <button onClick={() => scrollToId("#kontakt")} data-testid="team-cta" className="link-cta mt-6">
              Manfred Berglar kennenlernen <ArrowUpRight size={15} />
            </button>
        </Reveal>
      </div>
    </div>
  </section>
);
